import React from "react";

import { Grid, Typography } from "@material-ui/core";

import Page from "components/admin/Page";

import FilterUsers from "./FilterUsers";
import UsersTable from "./UsersTable";

import { selectUserInfo } from "modules/auth/authSlice";
import { useAppSelector } from "store";

const Users: React.FC = () => {
    const userInfo = useAppSelector(selectUserInfo);

    return (
        <Page dataCy="pages-admin-users">
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <br />
                    <Typography variant="subtitle1" component="div" color="textSecondary">
                        KPMG Admin - {userInfo.firstName} {userInfo.lastName}
                    </Typography>
                    <Typography variant="h3" component="div">
                        Users
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <FilterUsers />
                        </Grid>
                        <Grid item xs={12}>
                            <UsersTable />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Page>
    );
};

export default Users;
